export default "__VITE_ASSET__cy4RS$sw__"